import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { getSessionType } from '../Stores/Actions/userAction';
import { usePendingBooking, completeBookingPath } from './pendingBooking';

// The home page's "Book Your Session" action, shared by every button on it: a customer who already paid and has not
// picked a time is sent to finish that booking; otherwise to the booking page of Poonam (the astrologer whose
// AlternateName contains "poonam", else the first listed).
const useBookPoonam = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isBooking, setIsBooking] = useState(false);
  const { pending } = usePendingBooking();

  const bookSession = async () => {
    if (isBooking) return;

    if (pending) {
      navigate(completeBookingPath(pending.orderId));
      return;
    }

    setIsBooking(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/getAllAstrologers`);
      const list = response.data || [];
      const astrologer = list.find((item) => item.AlternateName?.toLowerCase().includes('poonam')) || list[0];
      if (!astrologer?.astroId) return;

      sessionStorage.setItem('chatType', 'call');
      dispatch(getSessionType('call'));
      navigate(`/book/${astrologer.astroId}`);
    } catch (error) {
      console.error(error);
    } finally {
      setIsBooking(false);
    }
  };

  const bookLabel = isBooking ? 'Loading' : pending ? 'Complete Your Booking' : 'Book Your Session';

  return { bookSession, bookLabel, isBooking };
};

export default useBookPoonam;
